module.exports = __webpack_public_path__ + "img/logo.f0dd7c96.png";